import { gql } from '../../../../../hooks'

export const DELETE_COLLECTIONS = gql`
  mutation AdministrationDeleteComponentCollections($id: ID!) {
    aDelete(path: "component/collections", id: $id) {
    }
  }
`

export const LIST_COLLECTIONS = gql`
  query AdministrationListComponentCollections(
    $page: Int
    $limit: Int
    $filter: JSONObject
  ) {
    aList(
      path: "component/collections"
      filter: $filter
      page: $page
      limit: $limit
    ) {
      pagination {
        page
        limit
        number_of_pages
      }
    }
  }
`
